import { config } from './../config';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { StoreService } from './store.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { catchError, map, shareReplay, take } from 'rxjs/internal/operators';
import { isPlatformBrowser } from '@angular/common';
import { of } from 'rxjs';


@Injectable()
export class HttpService {
  private API = config.API;
  private API2 = config.API2;
  private RESTAURANT_ID: string = '';
  private WEB_ACCESS_TOKEN_COOKIE = 'webAccessToken';
  public token: any;
  private RESTAURANT_NAME: any;
  private domain_name: any;
  private user_id: any;

  aboutPageData?: Observable<any>;
  dealPageData?: Observable<any>;
  menuPageData?: Observable<any>;
  reservationPageData?: Observable<any>;
  reviewPageData?: Observable<any>;
  galleryPageData?: Observable<any>;
  contactPageData?: Observable<any>;
  eventsPageData?: Observable<any>;
  orderPageData?: Observable<any>;
  awardPageData?: Observable<any>;
  blogPageData?: Observable<any>;
  teamPageData?: Observable<any>;
  xMasPageData?: Observable<any>;
  giftVoucherPageData?: Observable<any>;
  newsMediaPageData?: Observable<any>;
  getArticlesListByRestaurantData?: Observable<any>;

  getRestaurantContentData?: Observable<any>;
  getRestaurantData?: Observable<any>;
  getMenuData?: Observable<any>;
  mostPopularDishesData?: Observable<any>;
  getDeliveryAreasData?: Observable<any>;
  getPaymentMethodData?: Observable<any>;
  getFullScheduleData?: Observable<any>;
  getRestaurantScheduleData?: Observable<any>;
  getVersionInfoData?: Observable<any>;
  getBookingInfoData?: Observable<any>;
  

  getReviewsData?: Observable<any>;
  bookingDealsData?: Observable<any>;
  UserReviewsData?: Observable<any>;

  // Today Full Schedule Data
  fullScheduleData?: Observable<any>;

  // All schedule Data
  allScheduleData?: Observable<any>; 

  constructor(
    private http: HttpClient,
    private store: StoreService,
    @Inject(PLATFORM_ID) private readonly platformId: any
  ) {
    this.store.user.subscribe(res => {
      if (res) {
        if (res.isLogged) {
          this.token = res.token;
          this.user_id = res.data._id;
        } else {
          this.token = undefined;
          this.user_id = undefined;
        }
      }
    });

    this.store.restaurantData.subscribe(data => {
      if (Object.getOwnPropertyNames(data).length !== 0) {
        this.RESTAURANT_NAME = data.restaurant_data.restaurant_name;
        this.RESTAURANT_ID = data.restaurant_data.restaurant_id;
        this.domain_name = data.restaurant_data.domain;
      }
    });
  }

  private resolveRestaurantId(resId?: any): string {
    if (resId) {
      return resId;
    }

    if (this.RESTAURANT_ID) {
      return this.RESTAURANT_ID;
    }

    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('restaurant_id') || '';
    }

    return '';
  }

  private getEmptyPageData(pageId?: number): any {
    return {
      status: false,
      page_id: pageId,
      cover_image: null,
      seo_page_title: '',
      seo_meta: [],
      history_section: { images: [] },
      gallery_section: { gallery_images: [] },
      slider_section: { sliders: [] },
      news: [],
      media: []
    };
  }

  getRestaurantContent(resId: any): Observable<any> {
    // if (isPlatformBrowser(this.platformId)) {
    //   this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    // } else {
    //   this.RESTAURANT_ID = '';
    // }
    // let url = this.API + 'getRestaurantContent/' + this.RESTAURANT_ID;


    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API + 'getRestaurantContent/' + (resId ? resId : this.RESTAURANT_ID);


    return this.http.get<any>(url).pipe(shareReplay());
  }

  getRestaurantInfo(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API + 'getRestaurant/' + this.RESTAURANT_ID;
    if (this.getRestaurantData) {
      return this.getRestaurantData;
    } else {
      this.getRestaurantData = this.http.get<any>(url).pipe(shareReplay());
      return this.getRestaurantData;
    }
  }

  public findRestaurantData() {
    const hostname = isPlatformBrowser(this.platformId) ? location.hostname : '';
    // let hostname ="https://draft.thaiimperial.com";  //https://draft.thaiimperial.com //https://www.anokhi-restaurant.co.uk
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    let url = this.API + 'getRestaurantData?hostname=' + hostname;
    return this.http.get<Object>(url, { headers });
  }

  getWebApiAccessToken(restaurantId: string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${config.API2}getWebApiAccessToken/${restaurantId}`;
    return this.http.get<any>(url, { headers });
  }

  setWebAccessToken(token: string) {
    if (this.platformId === 'browser' && token) {
      const securePart = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = `${this.WEB_ACCESS_TOKEN_COOKIE}=${encodeURIComponent(token)}; Path=/; SameSite=Strict${securePart}`;
    }
  }

  getWebAccessToken() {
    if (this.platformId !== 'browser') {
      return '';
    }

    const cookieName = `${this.WEB_ACCESS_TOKEN_COOKIE}=`;
    const cookieList = document.cookie ? document.cookie.split(';') : [];

    for (let i = 0; i < cookieList.length; i++) {
      const cookie = cookieList[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return decodeURIComponent(cookie.substring(cookieName.length));
      }
    }

    return '';
  }

  getPageDataById_V2(pageId: number): Observable<any> {
    this.RESTAURANT_ID = this.resolveRestaurantId();

    if (!this.RESTAURANT_ID) {
      return of(this.getEmptyPageData(pageId));
    }

    const url = this.API + 'getPageDataById_V2/' + this.RESTAURANT_ID + '/' + pageId;
    const request$ = this.http.get<any>(url).pipe(
      map((data: any) => data || this.getEmptyPageData(pageId)),
      catchError((error) => {
        console.error(`Error loading page content for page ${pageId}:`, error);
        return of(this.getEmptyPageData(pageId));
      }),
      shareReplay()
    );

    if (pageId === 2) {
      if (this.aboutPageData) {
        return this.aboutPageData;
      }
      this.aboutPageData = request$;
      return this.aboutPageData;
    } else if (pageId === 3) {
      if (this.dealPageData) {
        return this.dealPageData;
      }
      this.dealPageData = request$;
      return this.dealPageData;
    } else if (pageId === 4) {
      if (this.menuPageData) {
        return this.menuPageData;
      }
      this.menuPageData = request$;
      return this.menuPageData;
    } else if (pageId === 5) {
      if (this.reservationPageData) {
        return this.reservationPageData;
      }
      this.reservationPageData = request$;
      return this.reservationPageData;
    } else if (pageId === 6) {
      if (this.reviewPageData) {
        return this.reviewPageData;
      }
      this.reviewPageData = request$;
      return this.reviewPageData;
    } else if (pageId === 7) {
      if (this.galleryPageData) {
        return this.galleryPageData;
      }
      this.galleryPageData = request$;
      return this.galleryPageData;
    } else if (pageId === 8) {
      if (this.contactPageData) {
        return this.contactPageData;
      }
      this.contactPageData = request$;
      return this.contactPageData;
    } else if (pageId === 9) {
      if (this.eventsPageData) {
        return this.eventsPageData;
      }
      this.eventsPageData = request$;
      return this.eventsPageData;
    } else if (pageId === 10) {
      if (this.orderPageData) {
        return this.orderPageData;
      }
      this.orderPageData = request$;
      return this.orderPageData;
    } else if (pageId === 11) {
      if (this.awardPageData) {
        return this.awardPageData;
      }
      this.awardPageData = request$;
      return this.awardPageData;
    } else if (pageId === 12) {
      if (this.blogPageData) {
        return this.blogPageData;
      }
      this.blogPageData = request$;
      return this.blogPageData;
    } else if (pageId === 13) {
      if (this.teamPageData) {
        return this.teamPageData;
      }
      this.teamPageData = request$;
      return this.teamPageData;
    } else if (pageId === 15) {
      if (this.giftVoucherPageData) {
        return this.giftVoucherPageData;
      }
      this.giftVoucherPageData = request$;
      return this.giftVoucherPageData;
    } else if (pageId === 16) {
      if (this.newsMediaPageData) {
        return this.newsMediaPageData;
      }
      this.newsMediaPageData = request$;
      return this.newsMediaPageData;
    } else if (pageId === 17) {
      if (this.xMasPageData) {
        return this.xMasPageData;
      }
      this.xMasPageData = request$;
      return this.xMasPageData;
    }

    return request$;
  }

  getMenu(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API + 'getMenu/' + this.RESTAURANT_ID;
    if (this.getMenuData) {
      return this.getMenuData;
    } else {
      this.getMenuData = this.http.get<any>(url).pipe(shareReplay());
      return this.getMenuData;
    }
  }

  addParcelInfo(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    data.restaurant_id = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'auth/addParcelInfo';
    return this.http.post(url, data, { headers: headers });
  }


  getParcelAddress(userId: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get<any>(config.API2 + 'auth/getParcelAddress/' + userId, { headers: headers });
  }

  removeUser(userHashId: string) {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('X-Access-Token', 'Bearer ' + this.token);
    const params = new HttpParams().set('_id', userHashId);
    return this.http.delete(config.API2 + 'auth/admin/removeUser', {
      headers: headers,
      params: params
    });
  }

  getGroupDishData(ids: any) {
    const data = { 'ids': ids };
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.post<any>(config.API2 + 'getGroupDishByIds', data, { headers: headers });
  }

  mostPopularDishes(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API2 + 'mostPopularDishes/' + this.RESTAURANT_ID;
    if (this.mostPopularDishesData) {
      return this.mostPopularDishesData;
    } else {
      this.mostPopularDishesData = this.http.get<any>(url).pipe(shareReplay());
      return this.mostPopularDishesData;
    }
  }

  reservationService(data: any): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    data.restaurant_id = this.RESTAURANT_ID;
    data.restaurant_name = this.RESTAURANT_NAME;
    /*return this.http.post(config.API2 + 'restaurant_reservations/create', data);*/

    const reqx = new HttpRequest('POST', config.API2 + 'restaurant_reservations/create', data, {
      reportProgress: true,
    });

    return this.http.request(reqx);
  }

  updateUserBooking(data: any, id: any, action: string) {
    if (this.platformId === 'browser') {
      const url = config.API2 + `restaurant_reservations/update?_id=${id}&action=${action}`;
      return this.http.put(url, data);
    }
  }

  loginService(body: any) {
    const url = config.API2 + 'loginAuth';
    return this.http.post(url, body);
  }
  checkExistUser(body: any) {
    const url = config.API2 + 'checkUserExistence';
    return this.http.post(url, body);
  }

  // registrationService(body: any) {
  //   if (isPlatformBrowser(this.platformId)) {
  //     this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
  //   } else {
  //     this.RESTAURANT_ID = '';
  //   }
  //   body.registered_restaurant_id = this.RESTAURANT_ID;
  //   const url = config.API2 + 'registration';
  //   return this.http.post(url, body); // ...using post request
  // }

  registrationService(body: any, token: string) {
    if (this.platformId === 'browser') {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
      body.registered_restaurant_id = this.RESTAURANT_ID;
      const url = config.API2 + 'registration';

      const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-form-secret': token
      })
    };

      return this.http.post(url, body, httpOptions); // ...using post request
    }
  }

  socialUserSignUp(body: any) {
    body.registered_restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'socialUserSignUp';
    return this.http.post(url, body); // ...using post request
  }

  verifyGuestUserToken(data: any) {
    data.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'verifyGuestUserToken';
    return this.http.post(url, data);
  }

  // guestLogin(body: any) {
  //   body.registered_restaurant_id = this.RESTAURANT_ID;
  //   const url = config.API2 + 'guestLogin';
  //   return this.http.post(url, body);
  // }

  guestLogin(body: any, token: string): Observable<any> {
    body.registered_restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'guestLogin';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-form-secret': token
      })
    };

    return this.http.post(url, body, httpOptions);
  }

  // NEW CODE FOR GET SECRET FOR SIGNUP 
  getFormSubmissionSecret(): Observable<any> {
    const url = config.API2 + 'formSubmissionSecret';
    return this.http.get(url);
  }

  /*//auth req*/
  postOrder(data: any): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    data.restaurant_id = this.RESTAURANT_ID;
    data.restaurant_name = this.RESTAURANT_NAME;
    const reqx = new HttpRequest('POST', config.API2 + 'auth/saveOrder', data, {
      reportProgress: true,
      headers: headers
    });
    return this.http.request(reqx);
  }

  /*//auth req*/
  updateUserInfo(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'auth/user/update';
    return this.http.put(url, data, { headers: headers });
  }

  addOrderAddress(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'auth/user/addOrderAddress';
    return this.http.put(url, data, { headers: headers });
  }

  /*//auth req*/
  checkPostCode(postcode: any) {
    return this.http.get('https://api.postcodes.io/postcodes/' + postcode);
  }

  getAreaCode(postcode: any) {
    return this.http.get('https://api.postcodes.io/postcodes/' + postcode);
  }

  // getHolidays(){
  //   return this.http.get('https://www.gov.uk/bank-holidays.json');
  // }

  /*//auth req*/
  getOrderDetails(order_id: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'auth/getOrderDetails/' + order_id, { headers: headers });
  }

  trackOrder(order_id: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'auth/trackOrder/' + order_id, { headers: headers });
  }

  getUserActivity(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'auth/user/activity/' + this.user_id + '/' + this.RESTAURANT_ID, { headers: headers });
  }

  getUserReservation(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'auth/getReservations/' + this.user_id + '/' + this.RESTAURANT_ID, { headers: headers });
  }


  // retriveAddressListByPostcode(postcode) {
  //   return this.http.get(
  //     `${config.API2}findWithPostcode/${postcode}`
  //   );
  // }

  retriveAddressListByPostcode(postcode: any) {
    const accessToken = this.token || this.getWebAccessToken();
    let headers = new HttpHeaders();
    if (accessToken) {
      headers = headers.set('X-Access-Token', 'Bearer ' + accessToken);
      // headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }
    // https://devoretapi.co.uk/api/v1/auth/goaddressFind?postcode=tn131dh
    const params = new HttpParams().set('postcode', postcode);
    // const url = `${config.API2}auth/loqateFind`;
    const url = `${config.API2}auth/goaddressFind`;
    return this.http.get(url, { headers, params });
  }

  retriveAddressByPostcode(postcode: any, address_line1: any) {
    return this.http.get(
      `${config.API2}findWithPostcodeAndHouse/${postcode}/${address_line1}`
    );
  }

  getDeliveryCharge(area_code: any, postcode: any) {
    return this.http.get(config.API2 + 'getDeliveryCharge/' + this.RESTAURANT_ID + '/' + area_code + '/' + postcode);
  }

  getPageContent(page_id: any) {
    return this.http.get(config.API2 + 'getPageContent/' + this.RESTAURANT_ID + '/' + page_id);
  }

  getGetPaymentMethod() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API2 + 'getPaymentMethod/' + this.RESTAURANT_ID;
    return this.http.get<any>(url);
  }

  /*//auth req*/
  getUserOrders() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'auth/customer_orders/' + this.user_id + '/' + this.RESTAURANT_ID, { headers: headers });
  }

  getReOrderData(orderId: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'getReOrderData?_id=' + orderId, { headers: headers });
  }

  createPayment(body: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    body.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'createPaymentWithCard';
    return this.http.post(url, body);
  }

  glorydaleCreateTransaction(body: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    body.restaurant_id = this.RESTAURANT_ID;
    const url = config.API3 + 'glorydaleCreateTransaction';
    return this.http.post(url, body);
  }


  getPayPalUrl(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    data.restaurant_id = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.post(config.API2 + 'auth/PayPal_payment', data, { headers: headers });
  }


  resendVerificationCode(data: any) {
    return this.http.post(config.API2 + 'resendVerificationCode', data);
  }

  changeMobileNumber(data: any) {
    return this.http.post(config.API2 + 'changeMobileNumber', data);
  }

  postUserReview(data: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    data.restaurant_id = this.RESTAURANT_ID;
    data.user_id = this.user_id;
    return this.http.post(config.API2 + 'auth/saveUserReview', data, { headers: headers });
  }

  getRestaurantReviews() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API2 + 'getReviews/' + this.RESTAURANT_ID;
    if (this.getReviewsData) {
      return this.getReviewsData;
    } else {
      this.getReviewsData = this.http.get<any>(url).pipe(shareReplay());
      return this.getReviewsData;
    }
  }

  getUserReview() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.get(config.API2 + 'auth/getUserReview/' + this.user_id + '/' + this.RESTAURANT_ID, { headers: headers });
  }

  sendContactFormEmail(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    data.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'sendContactFormEmail';
    return this.http.post(url, data);
  }

  sendForgotEmail(data: any) {
    data.restaurant_name = this.RESTAURANT_NAME;
    data.domain = this.domain_name;
    // data.version = 2;
    const url = config.API2 + 'sendForgetPasswordEmail';
    return this.http.post(url, data);
  }

  // sendForgotOtp(data: any) {
  //   const url = config.API2 + 'sendForgotPassOtp';
  //   return this.http.post(url, data);
  // }

  sendForgotOtp(data: any, token: string) {
    if (this.platformId === 'browser') {
      const url = config.API2 + 'sendForgotPassOtp';

      const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-form-secret': token
      })
    };

      return this.http.post(url, data, httpOptions); // ...using post request
    }
  }

  // sendEmailOTP(data: any) {
  //   const url = config.API2 + 'sendEmailOTP';
  //   return this.http.post(url, data);
  // }

  sendEmailOTP(data: any, token: string) {
    if (this.platformId === 'browser') {
      const url = config.API2 + 'sendEmailOTP';

      const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-form-secret': token
      })
    };

      return this.http.post(url, data, httpOptions); // ...using post request
    }
  }

  guestEmailOtp(data: any, token: string) {
    if (this.platformId === 'browser') {
      const url = config.API2 + 'guestEmailOtp';

      const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-form-secret': token
      })
    };

      return this.http.post(url, data, httpOptions); // ...using post request
    }
  }

  sendLoginOtp(data: any): Observable<any> {
    const url = config.API2 + 'sendLoginOtp';
    return this.http.post(url, data);
  }

  verifyForgetPasswordToken(data: any) {
    const url = config.API2 + 'verify_forget_password';
    return this.http.post(url, data);
  }

  changePassword(data: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.put(config.API2 + 'auth/reset_password', data, { headers: headers });
  }

  modifyPassword(data: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.put(config.API2 + 'auth/user/change_password', data, { headers: headers });
  }

  sendOrderConfirmationEmail(data: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    return this.http.post(config.API2 + 'auth/sendConfirmationEmail', data, { headers: headers });
  }

  getBookingDeals() {
    let url = this.API2 + 'bookingDeals/' + this.RESTAURANT_ID;
    if (this.bookingDealsData) {
      return this.bookingDealsData;
    } else {
      this.bookingDealsData = this.http.get<any>(url).pipe(shareReplay());
      return this.bookingDealsData;
    }
  }

  userReviews() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API2 + 'UserReviews/' + this.RESTAURANT_ID;
    if (this.UserReviewsData) {
      return this.UserReviewsData;
    } else {
      this.UserReviewsData = this.http.get<any>(url).pipe(shareReplay());
      return this.UserReviewsData;
    }
  }

  getDeliveryAreas() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API2 + 'getDeliveryAreas/' + this.RESTAURANT_ID;
    if (this.getDeliveryAreasData) {
      return this.getDeliveryAreasData;
    } else {
      this.getDeliveryAreasData = this.http.get<any>(url).pipe(shareReplay());
      return this.getDeliveryAreasData;
    }
  }

  getDeliveryDistance(origin: any, destination: any, sub_total: any, area_code: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    const data = {
      restaurant_id: this.RESTAURANT_ID,
      origin: origin,
      destination: destination,
      area_code: area_code,
      min_delivery_amount: sub_total
    };

    return this.http.post(config.API2 + 'getDeliveryInfo', data);
  }

  getGoogleReviews(postcode: any) {
    return this.http.get(config.API2 + 'getGoogleReview/' + postcode);
  }

  eventDetails(_id: any): Observable<any> {
    return this.http.get(config.API2 + 'event/' + _id);
  }

  getBlogListData() {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let url = this.API2 + 'getArticlesListByRestaurant/' + this.RESTAURANT_ID;
    if (this.getArticlesListByRestaurantData) {
      return this.getArticlesListByRestaurantData;
    } else {
      this.getArticlesListByRestaurantData = this.http.get<any>(url).pipe(shareReplay());
      return this.getArticlesListByRestaurantData;
    }
  }
  getBlogDataById(_id: any) {
    return this.http.get(config.API2 + 'getArticleById/' + _id);
  }
  getBlogDataBySlug(slug: any) {
    this.RESTAURANT_ID = this.resolveRestaurantId();
    return this.http.get(config.API2 + 'getArticleBySlug/' + slug + '?restaurant_id=' + this.RESTAURANT_ID);
  }


  registerEvent(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    data.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'registerEvent';
    return this.http.post(url, data);
  }

  createCardTransaction(data: any) {
    data.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'createTransaction';
    return this.http.post(url, data);
  }

  addUserCookiePolicy(data: any) {
    data.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'addUserCookiePolicy';
    return this.http.post(url, data);
  }

  addUserSubscribe(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    data.restaurant_id = this.RESTAURANT_ID;
    const url = config.API2 + 'addUserSubscribe';
    return this.http.post(url, data);
  }


  // New Payment APIS 
  reconcile_payment(uniqueId: string): Observable<any> {
    return this.http.get(`${this.API2}reconcile/${uniqueId}`).pipe(
      catchError(error => {
        console.error('Error reconciling payment:', error);
        return of(null);
      })
    );
  }

  private getStoredPaymentMethod() {
    let paymentMethod: any;
    this.store.paymentMethod.pipe(take(1)).subscribe(value => {
      if (Object.getOwnPropertyNames(value).length !== 0) {
        paymentMethod = value;
      }
    });

    if (!paymentMethod && isPlatformBrowser(this.platformId)) {
      const stored = sessionStorage.getItem('payment_method');
      if (stored) {
        paymentMethod = JSON.parse(stored);
      }
    }

    return paymentMethod;
  }

  createStripePaymentIntent(payload: any) {
    const paymentMethod = this.getStoredPaymentMethod();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Access-Token': 'Bearer ' + this.token,
      'payment-account': paymentMethod?.payment_account ?? config.STRIPE
    });

    const apiV2 = config.API2.replace('/v1/', '/v2/');
    const url = `${apiV2}auth/create-payment-intent`;
    return this.http.post(url, payload, { headers: headers });
  }

  retrieveStripePaymentIntent(paymentIntentId: string) {
    const paymentMethod = this.getStoredPaymentMethod();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Access-Token': 'Bearer ' + this.token,
      'payment-account': paymentMethod?.payment_account ?? config.STRIPE
    });
    const apiV2 = config.API2.replace('/v1/', '/v2/');
    const url = `${apiV2}auth/retrieve-payment-intent/${paymentIntentId}`;
    return this.http.get(url, { headers: headers });
  }

  getStripeCustomerList(payload: any) {
    const paymentMethod = this.getStoredPaymentMethod();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Access-Token': 'Bearer ' + this.token,
      'payment-account': paymentMethod?.payment_account ?? config.STRIPE
    });

    const apiV2 = config.API2.replace('/v1/', '/v2/');
    const url = `${apiV2}auth/get-stripe-customer-list`;
    return this.http.post(url, payload, { headers: headers });
  }

  createStripeCustomer(payload: any) {
    const paymentMethod = this.getStoredPaymentMethod();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Access-Token': 'Bearer ' + this.token,
      'payment-account': paymentMethod?.payment_account ?? config.STRIPE
    });

    const apiV2 = config.API2.replace('/v1/', '/v2/');

    const url = `${apiV2}auth/create-stripe-customer`;
    return this.http.post(url, payload, { headers: headers });
  }

  updateStripeOrderPaymentStatus(payload: any, orderId: string): Observable<any> {
    const headers = this.createAuthHeaders();
    return this.http.post(
      `${this.API2}auth/updateStripePaymentStatus?_id=${encodeURIComponent(orderId)}`,
      payload,
      { headers }
    ).pipe(
      catchError(error => {
        console.error('Error updating Stripe order payment status:', error);
        return of(null);
      })
    );
  }

  createAuthHeaders(): HttpHeaders {
    let token = this.token || '';

    if (!token && isPlatformBrowser(this.platformId)) {
      token = localStorage.getItem('token') || '';
    }

    const paymentMethod = this.getStoredPaymentMethod();
    const paymentAccount = paymentMethod?.payment_account ?? config.STRIPE;

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Access-Token': `Bearer ${token}`,
      'payment-account': paymentAccount,
    });
  }
// New Payment APIS END
  updatePaymentOfGiftVoucher(payload: any, _id: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'auth/updatePaymentOfGiftVoucher?id=' + _id;
    return this.http.post(url, payload, { headers: headers });
  }

  updateStripeBookingPaymentStatus(payload: any, booking_id: any) {
    // let headers = new HttpHeaders().set('Content-Type', 'application/json');
    // headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    // const url = config.API2 + 'auth/updateStripeBookingPaymentStatus?_id=' + booking_id;
    const url = config.API2 + 'updateStripeBookingPaymentStatus?_id=' + booking_id;
    return this.http.post(url, payload);
  }

  validateUserToken() {
    const url = config.API2 + 'validateUserToken?token=' + this.token;
    return this.http.get(url);
  }

  validateUserTokenPost(): Observable<any> {
    return this.http.post(`${config.API2}validateUserToken`, {
      token: this.token
    }).pipe(
      catchError(error => {
        console.error('Error validating user token:', error);
        return of(error);
      })
    );
  }

  getbookingSetting(): Observable<any> {
    this.RESTAURANT_ID = this.resolveRestaurantId();

    if (!this.RESTAURANT_ID) {
      return of({ status: false, data: null });
    }

    let params = new HttpParams();
    params = params.set('restaurant_id', this.RESTAURANT_ID);
    const url = config.API2 + 'admin/admin_getBookingInfo';
    return this.http.get(url, { params: params }).pipe(
      map((data: any) => data || { status: false, data: null }),
      catchError((error) => {
        console.error('Error loading booking settings:', error);
        return of({ status: false, data: null });
      })
    );
  }

  findCustomScheduleByDate(seletedBookingDate: any) {
    this.RESTAURANT_ID = this.resolveRestaurantId();
    let params = new HttpParams();
    params = params.set('restaurant_id', this.RESTAURANT_ID);
    params = params.set('selectedDate', seletedBookingDate);
    const url = config.API2 + 'findCustomScheduleByDate';
    return this.http.get(url, { params: params });
  }

  getBookingDetails(booking_id: any): Observable<any> {
    let params = new HttpParams();
    params = params.set('booking_id', booking_id);
    const url = config.API2 + 'getBookingByBookingId';
    return this.http.get(url, { params: params });
  }

  getBookingById(id: any): Observable<any> {
    const url = config.API2 + 'getBookingById?_id=' + id;
    return this.http.get(url);
  }

  applyPromoCode(payload: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    payload['restaurant_id'] = this.RESTAURANT_ID;
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'auth/userApplyPromoCode?promoFor=' + payload.promoFor;
    return this.http.post(url, payload, { headers: headers });
  }

  getVersionInfo(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'getVersionInfo?restaurant_id=' + this.RESTAURANT_ID;
    if(this.getVersionInfoData){
      return this.getVersionInfoData;
    }else{
      this.getVersionInfoData = this.http.get<any>(url, {headers: headers}).pipe(shareReplay());
      return this.getVersionInfoData;
    }
  }

  updatebookingInfo(bookingHashId: string, body: any) {
    const url = config.API2 + 'updateBookingOrderItems';
    let params = new HttpParams();
    params = params.set('rid', bookingHashId);
    return this.http.post<any>(url, body, { params: params });
  }

  getBookedTimeSlotList(date: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = localStorage.getItem('restaurant_id') || '';
    } else {
      this.RESTAURANT_ID = '';
    }
    const url = config.API2 + 'getBookedTimeSlotList';
    let params = new HttpParams();
    params = params.set('rid', this.RESTAURANT_ID);
    params = params.set('booking_date', date);
    return this.http.get<any>(url, { params: params }).pipe(
      map((data: any) => data || { status: false, data: [] }),
      catchError((error) => {
        console.error('Error loading booked time slots:', error);
        return of({ status: false, data: [] });
      })
    );
  }

  createGiftVoucher(body: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Access-Token', 'Bearer ' + this.token);
    const url = config.API2 + 'auth/createGiftVoucher';
    return this.http.post(url, body, { headers: headers });
  }

  // findNewFullSchedule is giving the full schedule of Today 
  findNewFullSchedule(resId?: any): Observable<any> {
    this.RESTAURANT_ID = this.resolveRestaurantId(resId);

    if (!this.RESTAURANT_ID) {
      return of(null);
    }

    const url = config.API2 + 'findNewFullSchedule';
    let params = new HttpParams();
    params = params.set('restaurant_id', this.RESTAURANT_ID);

    if (this.fullScheduleData) {
      return this.fullScheduleData;
    } else {
      this.fullScheduleData = this.http.get<any>(url, { params: params }).pipe(
        catchError((error) => {
          console.error('Error loading full schedule:', error);
          return of(null);
        }),
        shareReplay()
      );
      return this.fullScheduleData;
    }
  }

  // GET all schedule Data 
  fetchRestaurantSchedule(resId: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.RESTAURANT_ID = resId ? (resId) : (localStorage.getItem('restaurant_id') || '');
    } else {
      this.RESTAURANT_ID = '';
    }
    const url = config.API2 + 'fetchRestaurantSchedule';
    let params = new HttpParams();
    params = params.set('restaurant_id', this.RESTAURANT_ID);
    // return this.http.get<any>(url, { params: params });

    if (this.allScheduleData) {
      return this.allScheduleData;
    } else {
      this.allScheduleData = this.http.get<any>(url, { params: params }).pipe(
        map((data: any) => data || { status: false, data: [] }),
        catchError((error) => {
          console.error('Error fetching restaurant schedule:', error);
          return of({ status: false, data: [] });
        }),
        shareReplay()
      );
      return this.allScheduleData;
    }
  }

}


// /api/v1/website/getChainRestaurantsByHostName
    // /api/v1/website/getRestaurantContent/:rid
